<template>
    <Line :data="data" :options="options" />
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {
        Chart as ChartJS,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend,
    } from 'chart.js'
    import {Line} from 'vue-chartjs'

    ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend)

    @Component({
        components: {
            Line,
        },
    })
    export class LineChart extends Vue {
        @Prop({default: () => ({}), type: Object}) data

        options = {
            scales: {
                y: {
                    beginAtZero: true,
                    grid: {
                        display: true,
                    },
                },
                x: {
                    grid: {
                        display: false,
                    },
                },
            },
            legend: {
                display: true,
            },
            responsive: true,
            // maintainAspectRatio: false,
        }
    }
    export default LineChart
</script>
